export type DesignPreviewKind = "image" | "document" | "model" | "file";

const modelExtensions = new Set(["3mf", "obj", "stl", "step", "stp"]);

export function designPreviewKind(
  mediaType: string,
  displayName: string,
): DesignPreviewKind {
  const normalizedMediaType = mediaType.toLowerCase();
  const extension = displayName.split(".").pop()?.toLowerCase() ?? "";

  if (normalizedMediaType.startsWith("image/") && extension !== "svg") {
    return "image";
  }

  if (
    normalizedMediaType === "application/pdf" ||
    normalizedMediaType === "image/svg+xml" ||
    extension === "pdf" ||
    extension === "svg"
  ) {
    return "document";
  }

  if (
    modelExtensions.has(extension) ||
    normalizedMediaType.startsWith("model/")
  ) {
    return "model";
  }

  return "file";
}
